import { render, staticRenderFns } from "./oinp.vue?vue&type=template&id=324abf0e&"
import script from "./oinp.vue?vue&type=script&lang=js&"
export * from "./oinp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports